import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/movies";
import { typeMeta } from "@/lib/media";

interface MovieCardProps {
  item: MediaItem;
  variant?: "grid" | "compact";
}

export default function MovieCard({ item, variant = "grid" }: MovieCardProps) {
  const isCompact = variant === "compact";

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
      aria-label={`${item.title} 详情`}
    >
      <div className="relative aspect-[5/7] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - 蜜桃33影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/0 to-foreground-950/10 opacity-60 transition-opacity duration-300 group-hover:opacity-95" />

        <span className="absolute left-2 top-2 rounded-full bg-background-50/95 px-2 py-0.5 text-[11px] font-medium text-foreground-800 backdrop-blur">
          {typeMeta[item.type].label}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-semibold text-background-50">
          <i className="ri-star-fill text-[9px]" />
          {item.rating.toFixed(1)}
        </span>

        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full border border-background-50/60 bg-background-50/20 text-background-50 backdrop-blur-sm">
            <i className="ri-play-fill text-lg leading-none" />
          </span>
        </span>

        <div className="absolute inset-x-0 bottom-0 hidden translate-y-1 px-3 pb-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 sm:block">
          <p className="line-clamp-2 text-[11px] leading-relaxed text-background-100/90">
            {item.tagline}
          </p>
        </div>
      </div>

      <div className={isCompact ? "mt-2" : "mt-2.5"}>
        <h3
          className={`truncate font-medium text-foreground-900 transition-colors group-hover:text-primary-600 ${
            isCompact ? "text-sm" : "text-sm md:text-[15px]"
          }`}
        >
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {item.year} · {item.region}
          <span className="mx-1.5 text-foreground-300">|</span>
          {item.genres.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}